import React, { useState, useEffect, useContext } from 'react';
import { LegacyStack, Link, InlineError, ButtonGroup, Button, Collapsible } from '@shopify/polaris'
import { EditModal, Spinner } from '@thinkwell/react.polaris'
import { useReducerRequest, FormProvider } from '@thinkwell/react.common'
import { ShopContext } from '../../contexts/Shop'
import { CustomerContext } from '../../contexts/Customer'
import { RecursContext } from '../../contexts/Recurs'
import { HostContext } from '../../contexts/Host'
import {formatDate, formatDateIntl, oneMonthFromNow} from '../../DateUtil'

export default function EditRecur(props) {
  const [showPauseConfirm, setShowPauseConfirm] = useState(false)
  const [showCancelConfirm, setShowCancelConfirm] = useState(false)
  const [currentRequestState, setCurrentRequestState] = useState()
  const host = useContext(HostContext)
  const shop_name = useContext(ShopContext)
  const [customer] = useContext(CustomerContext)
  const [recurs, fetchRecurs, fetchRecursState, upsertRecur, setRecurs] = useContext(RecursContext)

  const [statePauseRecur, onPauseRecur] = useReducerRequest('post', {onSuccess: (response) => {
    upsertRecur(response.data)
    props.onPauseRecur && props.onPauseRecur(response.data)
  }});
  const [stateCancelRecur, onCancelRecur] = useReducerRequest('post', {onSuccess: (response) => {
    upsertRecur(response.data)
    props.onCancelRecur && props.onCancelRecur(response.data)
  }});
  const [stateResumeRecur, onResumeRecur] = useReducerRequest('post', {onSuccess: (response) => {
    upsertRecur(response.data)
    props.onResumeRecur && props.onResumeRecur(response.data)
  }});

  const pauseRecur = () => {
    setCurrentRequestState(statePauseRecur)
    onPauseRecur(`${host}/accounts/recurs/${recur.id}/pause?shop=${recur.shopify_domain}`)
  }
  const resumeRecur = () => {
    setCurrentRequestState(stateResumeRecur)
    onResumeRecur(`${host}/accounts/recurs/${recur.id}/resume?shop=${recur.shopify_domain}`)
  }
  const cancelRecur = () => {
    setCurrentRequestState(stateCancelRecur)
    onCancelRecur(`${host}/accounts/recurs/${recur.id}/cancel?shop=${recur.shopify_domain}`)
  }

  const recur = props.recur || recurs.find((recur) => recur.matches(props.orderId))

  const onActive = (active) => {
    if (active && !recur) {
      fetchRecurs(`${host}/accounts/recurs?customer_id=${customer.id}&force=true`)
    }
    props.onActive && props.onActive(active)
  }

  const data = {}
  const customAttributes = recur && recur.lines[0].customAttributes
  const properties = Object.assign({}, props.properties || {})
  if (customAttributes) {
    customAttributes.reduce((properties, attr) => {
      properties[attr.key] ||= attr.value
      return properties
    }, properties)
  }

  const lastPayment = (recur && recur.payments || []).sort((a, b) => {
    return new Date(b.createdAt) - new Date(a.createdAt)
  })[0]
  const lastPaymentDate = lastPayment && lastPayment.createdAt

  return (<FormProvider data={data}><EditModal
    active={props.active}
    onActive={onActive}
    onSaving={props.onSaving}
    linkText='Manage Subscription'
    title="Manage Subscription"
    saveText={false}>
    <div>
      <Spinner active={fetchRecursState.loading}>
        { currentRequestState && !currentRequestState.requesting && currentRequestState.error ?
          <InlineError message={(<div className="submit-error">{currentRequestState.error}</div>)} fieldID="submitErrorFieldID" />
        : null }
        {
          recur ?
            <LegacyStack vertical>
              <LegacyStack.Item>Status : {recur.status}</LegacyStack.Item>
              <LegacyStack.Item><span title={formatDateIntl(lastPaymentDate, true)}>Last payment date : {formatDate(lastPaymentDate)}</span></LegacyStack.Item>
              {
                recur.nextOrderDate ?
                <LegacyStack.Item>
                  <span title={formatDateIntl(recur.nextOrderDate, true)}>Next payment date : {recur.status == 'PAUSED' ? '--' : formatDate(recur.nextOrderDate)}</span>
                </LegacyStack.Item> : null
              }
              { recur.status == 'PAUSED' ?
                <LegacyStack.Item>
                  <Spinner active={stateResumeRecur.requesting}><Link onClick={resumeRecur}>Resume Subscription</Link></Spinner>
                </LegacyStack.Item> : null }
              { recur.status == 'ACTIVE' ?
                <LegacyStack.Item>
                  <Spinner active={statePauseRecur.requesting}><Link onClick={() => setShowPauseConfirm(true)}>Pause Subscription</Link></Spinner>
                  <Collapsible open={showPauseConfirm} transition={{duration: '500ms', timingFunction: 'ease-in-out'}}>
                    <div>Are you sure you want to pause this subscription?</div>
                    <ButtonGroup>
                      <Button onClick={() => setShowPauseConfirm(false)}>No</Button>
                      <Button primary onClick={() => {setShowPauseConfirm(false); pauseRecur() }}>Pause</Button>
                    </ButtonGroup>
                  </Collapsible>
                </LegacyStack.Item> : null }
              { ['CANCELLED', 'EXPIRED', 'FAILED'].indexOf(recur.status) != -1 && recur.lines.length > 0 ?
                <LegacyStack.Item>
                  <form id="registration-form" action="/cart/add" method="post">
                    { properties && Object.keys(properties).map((key) => {
                        let value = properties[key]
                        return <input key={key} type="hidden" name={`properties[${key}]`} value={value} />
                      })
                    }
                    <input type="hidden" name="selling_plan" value={recur.lines[0].sellingPlanId} />
                    <input type="hidden" name="id" value={recur.lines[0].variantId} />
                    <input type="submit" className="button" value="Restart Subscription" />
                  </form>
                </LegacyStack.Item> : null }
              { ['ACTIVE', 'PAUSED'].indexOf(recur.status) != -1 ?
                <LegacyStack.Item>
                  <Spinner active={stateCancelRecur.requesting}><Link onClick={() => setShowCancelConfirm(true)}>Cancel Subscription</Link></Spinner>
                  <Collapsible open={showCancelConfirm} transition={{duration: '500ms', timingFunction: 'ease-in-out'}}>
                    <div>Are you sure you want to cancel this subscription?</div>
                    <ButtonGroup>
                      <Button onClick={() => setShowCancelConfirm(false)}>No</Button>
                      <Button primary onClick={() => {setShowCancelConfirm(false); cancelRecur() }}>Cancel</Button>
                    </ButtonGroup>
                  </Collapsible>
                </LegacyStack.Item> : null }
            </LegacyStack> : (!fetchRecursState.loading ? <div>No Subscription Found</div> : null)
        }
      </Spinner>
    </div>
  </EditModal></FormProvider>);
}
